import styled, { css } from "styled-components";

import Chip from "@material-ui/core/Chip";

const opensans = (props) => props.theme.fonts.opensans;

export const StyledChip = styled(Chip)`
  background-color: ${(props) => props.theme.palette[props.bgcolor]} !important;
  color: ${(props) => props.theme.palette[props.textcolor]} !important;
  margin: ${(props) => props.spacing}px;
  ${(props) =>
    props.title &&
    css`
      margin: 5;
      width: 100% !important;
      .MuiChip-root span {
        font-family: ${opensans};
      }
    `};

  ${(props) =>
    props.$productHeader &&
    css`
      .MuiChip-label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 70%;

        .MuiSvgIcon-root {
          width: .8em;
          height .8em;
          margin-left: 15px;

          &:hover {
            cursor: pointer;
          }
        }
      }
    `}
`;
